import React, { ReactNode } from 'react';
import {
  defineMessages,
  FormattedMessage,
  MessageDescriptor,
} from 'react-intl';
import { Inverter } from '../../../core/src/shared/enums';
import {
  SolaxEMS1000InverterName,
  SolaxEMS1000PROInverterName,
  SolaxMode,
} from '../shared';
import { useSelector } from '../store/utils';

export const emsModeOptions: Record<SolaxMode, ReactNode> = {
  [SolaxMode.SelfUse]: (
    <FormattedMessage
      id="ems.inverter.mode.selfUse"
      defaultMessage="Self use"
    />
  ),
  [SolaxMode.FeedIn]: (
    <FormattedMessage id="ems.inverter.mode.feedIn" defaultMessage="Feed-in" />
  ),
  [SolaxMode.Backup]: (
    <FormattedMessage id="ems.inverter.mode.backup" defaultMessage="Backup" />
  ),
  [SolaxMode.Manual]: (
    <FormattedMessage id="ems.inverter.mode.manual" defaultMessage="Manual" />
  ),
  [SolaxMode.PeakShaving]: (
    <FormattedMessage
      id="ems.inverter.mode.peakShaving"
      defaultMessage="Peak Shaving"
    />
  ),
};

export const ems1000InverterNameMessages = defineMessages({
  [SolaxEMS1000InverterName.NotConnected]: {
    id: 'ems.inverter.name.notConnected',
    defaultMessage: 'Nepřipojeno',
  },
  [SolaxEMS1000InverterName.TRENE100KI]: {
    id: 'ems.inverter.name.trene100ki',
    defaultMessage: 'X3-TRENE-100KI',
  },
  [SolaxEMS1000InverterName.AELIO]: {
    id: 'ems.inverter.name.aelio',
    defaultMessage: 'X3-AELIO',
  },
  [SolaxEMS1000InverterName.TRENE100K]: {
    id: 'ems.inverter.name.trene100k',
    defaultMessage: 'X3-TRENE-100K',
  },
  [SolaxEMS1000InverterName.TRENE125K]: {
    id: 'ems.inverter.name.trene125k',
    defaultMessage: 'X3-TRENE-125K',
  },
}) as Record<SolaxEMS1000InverterName, MessageDescriptor>;

export const ems1000ProInverterNameMessages = defineMessages({
  [SolaxEMS1000PROInverterName.NotConnected]: {
    id: 'emsPro.inverter.name.notConnected',
    defaultMessage: 'Nepřipojeno',
  },
  [SolaxEMS1000PROInverterName.TRENE1]: {
    id: 'emsPro.inverter.name.trene1',
    defaultMessage: 'X3-TRENE-1',
  },
  [SolaxEMS1000PROInverterName.AELIO]: {
    id: 'emsPro.inverter.name.aelio',
    defaultMessage: 'X3-AELIO',
  },
  [SolaxEMS1000PROInverterName.TRENE100K]: {
    id: 'emsPro.inverter.name.trene100k',
    defaultMessage: 'X3-TRENE-100K',
  },
  [SolaxEMS1000PROInverterName.TRENE125K]: {
    id: 'emsPro.inverter.name.trene125k',
    defaultMessage: 'X3-TRENE-125K',
  },
  [SolaxEMS1000PROInverterName.X3PROG2]: {
    id: 'emsPro.inverter.name.x3prog2',
    defaultMessage: 'X3-PRO G2',
  },
  [SolaxEMS1000PROInverterName.X3FORTH]: {
    id: 'emsPro.inverter.name.x3forth',
    defaultMessage: 'X3-FORTH',
  },
  [SolaxEMS1000PROInverterName.X3MGAG2]: {
    id: 'emsPro.inverter.name.x3mgag2',
    defaultMessage: 'X3-MGA G2',
  },
  [SolaxEMS1000PROInverterName.X3GRAND]: {
    id: 'emsPro.inverter.name.x3grand',
    defaultMessage: 'X3-GRAND',
  },
  [SolaxEMS1000PROInverterName.X3FORTHPLUS]: {
    id: 'emsPro.inverter.name.x3forthplus',
    defaultMessage: 'X3-FORTH+',
  },
}) as Record<SolaxEMS1000PROInverterName, MessageDescriptor>;

export const subInverterNameMapping = {
  [Inverter.SolaxEMS1000]: ems1000InverterNameMessages,
  [Inverter.SolaxEMS1000PRO]: ems1000ProInverterNameMessages,
};

export const useEmsInstalled = () => {
  return useSelector(({ variables }) => {
    const hasEmsInverter = Object.values(variables.INVERTER_CONFIG ?? {}).some(
      (config) =>
        [Inverter.SolaxEMS1000, Inverter.SolaxEMS1000PRO].includes(config.type)
    );
    return hasEmsInverter || variables.EMS;
  });
};
